window.options.slickOptions.slidesToScroll = 4;
window.options.phoneNumberNotRequiredCountries = ['Germany'];
